export default "__VITE_ASSET__rgAznhzN__"